class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    if(this.mainDetailsToggle){
      this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;


      this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
      this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
 }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    if (!this.mainDetailsToggle) {
      this.megaMenuTrigger = this.querySelector('.mega-menu-trigger');
      this.megaMenuContent = this.querySelector('.mega-menu__content');

      if (!this.megaMenuTrigger || !this.megaMenuContent) return;

      this.addEventListener('mouseenter', this.onMegaMenuMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMegaMenuMouseLeave.bind(this));
      this.addEventListener('focusin', this.onMegaMenuFocusIn.bind(this));
      this.addEventListener('focusout', this.onMegaMenuFocusOut.bind(this));
      this.addEventListener('keydown', this.onMegaMenuKeydown.bind(this));
      this.megaMenuTrigger.addEventListener('click', this.onMegaMenuTriggerClick.bind(this));
    }
  }

  openMegaMenu() {
    if (!this.megaMenuTrigger) return;
    this.setAttribute('data-open', '');
    this.megaMenuTrigger.setAttribute('aria-expanded', 'true');
  }

  closeMegaMenu() {
    if (!this.megaMenuTrigger) return;
    this.removeAttribute('data-open');
    this.megaMenuTrigger.setAttribute('aria-expanded', 'false');
  }

  onMegaMenuMouseEnter() {
    this.megaMenuPointerInside = true;
    this.megaMenuEscapeClosed = false;
    this.removeAttribute('data-escape-closed');
    this.openMegaMenu();
  }

  onMegaMenuMouseLeave() {
    this.megaMenuPointerInside = false;
    if (!this.contains(document.activeElement)) {
      this.megaMenuEscapeClosed = false;
      this.removeAttribute('data-escape-closed');
      this.closeMegaMenu();
    }
  }

  onMegaMenuFocusIn() {
    if (!this.megaMenuEscapeClosed) this.openMegaMenu();
  }

  onMegaMenuFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement) && !this.megaMenuPointerInside) {
        this.megaMenuEscapeClosed = false;
        this.removeAttribute('data-escape-closed');
        this.closeMegaMenu();
      }
    });
  }

  onMegaMenuTriggerClick() {
    this.megaMenuEscapeClosed = false;
    this.removeAttribute('data-escape-closed');
    this.openMegaMenu();
  }

  onMegaMenuKeydown(event) {
    if (event.key !== 'Escape') return;
    event.preventDefault();
    this.megaMenuEscapeClosed = true;
    this.setAttribute('data-escape-closed', '');
    this.closeMegaMenu();
    this.megaMenuTrigger.focus();
  }

  close() {
    if (!this.mainDetailsToggle) {
      this.closeMegaMenu();
      return;
    }
    super.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
